<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      paddingTop: '20px',
      position: 'relative',
      bottom: '20px'
    }"
    id="transactions"
    @scroll="onScroll"
  >
    <gift-popup-trans
      :model="transGC"
      v-if="transGC.gift_card && transGC.gift_card.show_popup"
    ></gift-popup-trans>
    <div class="padding-top-5"></div>
    <div class="margin-10">
      <div
        class="bg-light margin-bottom-5 box-shadow"
        :style="{
          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
          borderRadius: '10px'
        }"
      >
        <div
          class="balance-header align-hor center-ver space-between padding-10"
        >
          <div
            style="
              border-bottom: 1px solid #e1e6ea;
              display: flex;
              justify-content: start;
              align-items: center;
              padding-bottom: 5px;
              width: 100%;
            "
          >
            <div
              class="align-ver start-align-self"
              style="display: flex; align-items: flex-start"
            >
              <div class="align-hor center-ver">
                <div class="w10 margin-right-5 padding-left-5">
                  <img class="full-width" :src="reward_icon" />
                </div>
                <div class="text-left">
                  <div class="text-small margin-bottom-5">Balance</div>
                  <div
                    class="font-bold"
                    style="color: #000000"
                    v-if="walletBalance"
                  >
                    {{ walletBalance }}
                  </div>
                </div>
                <!-- <p>sds</p> -->
                <!-- <p v-if="active_currency !== reward_type">{{ reward_type }}qq</p> -->
              </div>
              <div
                class="text-small font-medium padding-top-5 wallet-message"
                v-if="walletBalance"
                :style="{
                  color: '#000000'
                }"
              >
                {{ getWalletMessage() }}
              </div>
            </div>

            <div>
              <div
                class="wrap align-hor center-ver center-hor padding-0510 pointer"
                @click.stop.prevent="
                  reward_type === 'Cash'
                    ? redirectTo('redeem', { bal: walletBalance })
                    : redirectTo('gift-cards')
                "
                :style="{
                  borderRadius: '15px',
                  fontSize: '12px',
                  background: isDarkTheme ? buttonBGColor : bgTheme,
                  color: isDarkTheme ? headingTextColor : '#ffffff'
                }"
                v-if="redeemable === true && showActionButtonInRewards"
              >
                Redeem
              </div>

              <div
                class="wrap align-hor center-ver center-hor padding-0510 pointer"
                @click.stop.prevent="
                  reward_type === 'Cash'
                    ? redirectTo('redeem', { bal: walletBalance })
                    : redirectTo('gift-cards')
                "
                :style="{
                  borderRadius: '15px',
                  fontSize: '12px',
                  background: isDarkTheme ? buttonBGColor : bgTheme,
                  color: isDarkTheme ? headingTextColor : '#ffffff'
                }"
                v-if="active_currency === reward_type && redeemable === true && showActionButtonInRewards"
              >
                <!-- <img class="smaller-icon pull-left margin-right-5" src="@/assets/gift-box-o.svg"> -->
                Redeem
              </div>

              <div
                class="wrap align-hor center-ver center-hor radius-5 pointer"
                @click.stop.prevent
                :style="{
                  background: '#CCCCCC',
                  color: isDarkTheme ? headingTextColor : '#ffffff'
                }"
                v-if="
                  useWallet && redeemable === false && reward_type === 'Cash'
                "
                style="font-size: 12px; border-radius: 20px; padding: 5px 15px"
              >
                Redeem
              </div>

              <div
                class="wrap align-hor center-ver center-hor padding-0510 radius-5 text-light pointer"
                :style="{
                  background: reward_type != 'Cash' ? bgTheme : '#CCCCCC'
                }"
                v-else-if="
                  useWallet && redeemable === false && reward_type === 'Cash'
                "
                @click.stop.prevent="
                  reward_type != 'Cash' ? redirectTo('gift-cards') : ''
                "
              >
                Redeem
              </div>
            </div>
          </div>
        </div>
        <div
          class="align-hor space-between center-ver text-semi-small padding-10"
          :class="trans.is_gift_debit ? 'pointer' : ''"
          v-for="(trans, index) in transactionData"
          :key="index"
          @click="trans.is_gift_debit ? showGCTrans(trans) : ''"
          ref="transactionList"
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
            borderBottom: '1px solid ' + (isDarkTheme ? '#00008B' : '#D3D3D3'),
            borderBottomLeftRadius:
              index === transactionData.length - 1 ? '10px' : '0px',
            borderBottomRightRadius:
              index === transactionData.length - 1 ? '10px' : '0px'
          }"
        >
          <div class="text-left">
            <div class="reward-name" style="font-weight: 500; color: #323232">
              {{ trans.message ? trans.message : "-" }}
            </div>
            <div
              class="reward-number padding-top-10"
              style="font-weight: 500; color: #323232"
            >
              #{{
                trans.is_earned == "true"
                  ? trans.credit_reference
                  : trans.debit_reference
              }}
            </div>
          </div>
          <div class="text-right">
            <div
              style="color: #258827"
              class="reward-amount"
              v-if="trans.is_earned == 'true'"
            >
              +{{ formatReward(reward_type, trans.value, true) }}
            </div>
            <div class="reward-amount text-red" v-else>
              -{{ formatReward(reward_type, trans.value, true) }}
            </div>
            <div
              class="reward-time padding-top-10"
              style="font-weight: 500; color: #323232"
            >
              {{ trans.created_at | moment }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="bg-light box-shadow trans-fade"
        v-if="transactionData.length === 0 && showShimmer"
      >
        <div class="align-hor center-ver space-between padding-10">
          <div class="w70">
            <div class="align-hor center-ver">
              <div class="w15 margin-right-10">
                <div class="wrapper">
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
              <div class="w40">
                <div class="wrapper">
                  <div class="comment animate margin-bottom-5 w85"></div>
                  <div class="comment animate w50"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="w20">
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>

        <div
          class="align-hor center-ver space-between bg-light padding-10"
          v-for="$i in 2"
        >
          <div class="w40">
            <div class="wrapper">
              <div class="comment animate margin-bottom-5"></div>
              <div class="comment animate w50"></div>
            </div>
          </div>
          <div class="w20">
            <div class="wrapper align-ver end-ver">
              <div class="comment animate w50 margin-bottom-5"></div>
              <div class="comment animate w85"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import GiftCardPopupTrans from "@/components/gift-card-popup-trans";
import moment from "moment";
export default {
  mixins: [globals],
  props: {
    model: Object
  },
  components: {
    "gift-popup-trans": GiftCardPopupTrans
  },
  data() {
    return {
      all_transactions: [],
      page: 1,
      reward_icon: "",
      reward_type: "",
      balance: 0,
      is_redeemable: false,
      transGC: {},
      is_shimmer: true,
      balCheck: 0,
      active_currency: "",
      lastTransaction: false
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    isDescriptionColour() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDescriptionColour
      ) {
        return this.$store.state.sdkEvent.isDescriptionColour;
      }
      return null;
    },

    transactionData: function() {
      return this.all_transactions;
    },
    redeemable: function() {
      return this.is_redeemable;
    },
    walletBalance: function() {
      return this.balance;
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  methods: {
    getWalletTransactions() {
      console.log(`page: ${this.page}`);
      var url =
        this.$store.getters.flyyDomain +
        "/web_cash_transactions?page=" +
        this.page +
        "&prize_type=" +
        this.reward_type;
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers
        })
        .then(resp => {
          var data = resp.data;
          this.reward_icon = data.reward_icon;
          this.reward_type = data.reward_type;
          this.is_redeemable = data.is_redeemable;
          this.$store.state.user.headerBalance.icon = data.reward_icon;
          this.balCheck = data.balance;
          this.balance = this.formatReward(
            data.reward_type,
            data.balance,
            true
          );
          this.$store.state.user.headerBalance.balance = this.balance;
          var result = [];
          if (data.all_logs && data.all_logs.length > 0) {
            data.all_logs.forEach(trans => {
              if (
                trans.debit_type &&
                trans.debit_type.includes("gift") &&
                trans.gift_card
              ) {
                trans.gift_card.show_popup = false;
                trans.is_gift_debit = true;
              } else {
                trans.is_gift_debit = false;
              }

              result.push(trans);
            });
          }
          result.forEach(rest => {
            this.all_transactions.push(rest);
          });
          //this.all_transactions = {...this.all_transactions, ...result };
          if (data.logs_count >= this.all_transactions.length) {
            this.page += 1;
          } else {
            this.lastTransaction = true;
          }
          this.is_shimmer = false;
        });
    },
    showGCTrans(trans) {
      this.transGC = trans;
      this.transGC.gift_card.show_popup = true;
    },
    getWalletMessage() {
      return this.$store.state.user.balances.filter(i => {
        return i.reward_type === this.reward_type;
      })[0]["wallet_message"];
    },
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      //console.log(`scrollTop : ${scrollTop} | clientHeight : ${clientHeight} | scrollHeight : ${scrollHeight}`);
      if (scrollTop + clientHeight >= scrollHeight && !this.lastTransaction) {
        this.getWalletTransactions();
      }
    }
  },
  filters: {
    // moment: function(date) {
    //   let dateNow = new Date();
    //   let dateInp = new Date(date);
    //   let diff = (dateNow - dateInp) / 1000 / 60 / 60 / 24;
    //   if (diff <= 7) {
    //     return moment(date).format("DD MMM YY[, ]hh:mm A");
    //   } else {
    //     return moment(date).format("DD MMM YY[, ]hh:mm A");
    //   }
    // }
    moment: function(date) {
      let dateNow = new Date();
      let dateInp = new Date(date);
      let diff = (dateNow - dateInp) / 1000 / 60 / 60 / 24;
      return moment(date).format("DD MMM YY[, ]hh:mm A");
    }
  },
  created() {
    if (!this.isEmpty(this.$route.query)) {
      this.reward_type = this.$route.query.type;
    }
    var store_state = this.$store.state;
    store_state.showHeader = true;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.headTitle = "Transactions";
    store_state.user.headerBalance.show = false;
    this.active_currency =
      this.$route.query.active_currency ||
      this.$store.state.active_currency.label; //this.$route.query.active_currency
    this.getWalletTransactions();
  }
};
</script>
